
import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartOptions } from 'chart.js';
import { Notifications } from '@material-ui/icons';
import file from '../../../assets/excelFile.svg'
import commonStyles from '../../common/common.module.css';
import styles from '../analytics.module.css';
import { Chart } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface ScreeningAlarmProps {
  alarms: number[];
  alarmCount: number;
  handleExport: (type: string) => void;
};

const ScreeningAlarm = (props: ScreeningAlarmProps) => {

  const data = {
    labels: ['Inner ETD', 'Phy Search', 'XRY', 'Ret To Cust'],
    datasets: [
      {
        barPercentage: 0.5,
        data: props.alarms,
        backgroundColor: 'rgb(0,50,94)'
      },
    ],
  };

  const graphOptions: ChartOptions = {
    plugins: {
      legend: {
        fullSize: true,
        display: false,
      },
      datalabels: {
        formatter: (value, ctx) => {
          let sum = 0;
          let dataArr = ctx.chart.data.datasets[0].data;
          dataArr.map(data => {
            if (typeof data == 'number')
              sum += data;
          });
          let result = value * 100 / sum
          let percentage = (result).toFixed(0) + "%";
          if (result > 0) {
            return percentage;
          } else {
            return '';
          }
        },
        color: '#fff',
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          drawOnChartArea: false,
        },
      },
    }
  };

  return (
    <div className={`${styles.wtOuterGridItems}`}>
      <div className={`${commonStyles.fSpaceBtw} ${commonStyles.flexWrap}`}>
        <h5 className={styles.heading}>Screening Alarms</h5>
        <div className={`${styles.fileImg}`} onClick={() => props.handleExport('alarms')}>
          <img src={file} alt="file" />
        </div>
      </div>
      <div className={`${commonStyles.dFlex} ${commonStyles.flexWrap} ${commonStyles.gap20}`}>
        <div className={`${commonStyles.mxauto}`}>
          <div className={`${commonStyles.dFlex} ${commonStyles.positionRelative}`}>
            <Notifications classes={{ root: styles.saBell }} />
            <span className={styles.totalAlarms}>{props.alarmCount}</span>
          </div>
          <div className={styles.totalAlarmsText}>Total Alarms</div>
        </div>
        <div className={`${styles.graphWrapper} ${styles.saGrapgWrap}`}>
          <div className={styles.barWrapper}>
            <Chart type={'bar'} data={data} options={graphOptions} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScreeningAlarm;